export const TABLE_TABS_PREFIX = 'tab_';
export const TEMPLATE_PREFIX = 'template_';
export const TEST_DATA_PATH = 'test-data';

export const listTypes = {
    PRODUCTION_LIST: 'productionList',
    TEST_LIST: 'testList',
    WATERPIPE_LIST: 'waterpipeList',
    SERIAL_NUMBERS: 'serialNumbers',
};

export const listTypesId = {
    PRODUCTION_LIST: 1,
    TEST_LIST: 2,
};

export const testListVersion = {
    V1: 1,
    V2: 2,
};

export const listTypesNames = {
    PRODUCTION_LIST: 'produkcyjne',
    TEST_LIST: 'testowe',
};

export const ROLE = {
    ADMIN: 1,
    USER: 2,
    TECHNICIAN: 3,
};

export const ROLE_NAMES = {
    [ROLE.ADMIN]: 'Administrator',
    [ROLE.USER]: 'Użytkownik',
    [ROLE.TECHNICIAN]: 'Technik',
};

export const PERMISSION_DEFAULTS = ['packages', 'waterworks'];

export const PERMISSIONS = {
    start: 'Statystyka',
    packages: 'Pakiety',
    uniques: 'Unikaty',
    waterworks: 'Wodociągi',
    generator: 'Generator',
    gateways: 'Bramki',
    users: 'Użytkownicy',
    protocols: 'Protokoły',
    summaries_production: 'Zestawienia produkcyjne',
    fw: 'Moduł FW',
    parsing: 'Automatyczne parsowanie',
    summaries_test: 'Zestawienia testowe',
};

// Each module owns one bit of the users.permissions smallint bitmask.
// Bit positions follow PERMISSIONS entry order (start = 1, packages = 2,
// uniques = 4, ...), matching config/permissions.php on the backend. New
// modules must be appended, never inserted, so summaries_production keeps the
// bit the old summaries key held and summaries_test takes a fresh one.
export const PERMISSION_BITS = Object.fromEntries(
    Object.keys(PERMISSIONS).map((permission, index) => [permission, 1 << index])
);

export const PERMISSION_DEFAULTS_BITMASK = PERMISSION_DEFAULTS.reduce(
    (bitmask, permission) => bitmask | (PERMISSION_BITS[permission] ?? 0),
    0
);

// Display order for the admin toggles, independent of the bit order above so
// the two Zestawienia permissions sit next to each other in the form.
export const PERMISSION_DISPLAY_ORDER = [
    'start',
    'packages',
    'uniques',
    'waterworks',
    'generator',
    'gateways',
    'users',
    'protocols',
    'summaries_production',
    'summaries_test',
    'fw',
    'parsing',
];

export const responseCode = {
    SUCCESS: 200,
};

export const tableTranslations = {
    filterOoo: 'Filtr...',
    contains: 'Zawiera',
    notContains: 'Nie zawiera',
    equals: 'Równa się',
    notEqual: 'Nie równe',
    greaterThan: 'Większe niż',
    lessThan: 'Mniejsze niż',
    inRange: 'W zakresie',
    startsWith: 'Zaczyna się od',
    endsWith: 'Kończy się na',
    andCondition: 'ORAZ',
    orCondition: 'LUB',
    noRowsToShow: 'Brak danych do wyświetlenia',
    loadingOoo: 'Trwa wczytywanie danych...',
    errorLoadingData: 'Wystąpił błąd podczas pobierania danych.',
    to: 'do',
    of: 'z',
    page: 'Strona',
};

export const submenuElementList = {
    FIRST_ELEMENT: 'firstElement',
    SECOND_ELEMENT: 'secondElement',
};

export const settingsMenuItems = [
    { permissions: ['users'], path: '/users', label: 'Użytkownicy' },
    { permissions: ['generator'], path: '/generator', label: 'Generator' },
    { permissions: ['gateways'], path: '/gateways', label: 'Bramki' },
    { permissions: ['protocols'], path: '/protocols', label: 'Protokoły' },
    { permissions: [], path: '/settings', label: 'Ustawienia', visibleToAllUsers: true },
];

export const endpoint = {
    USER_LOGIN: '/api/user/login',
    USER_LOGOUT: '/api/user/logout',
    USER_CURRENT: '/api/user',
    USER_CHANGE_PASSWORD: '/api/user/change-password',
    USER_CREATE: '/api/user/create',
    USER_UPDATE: '/api/user/update',
    USER_DELETE: '/api/user/delete',
    SCHEME_CREATE: `/api/scheme/create`,
    SCHEME_DELETE: '/api/scheme/delete',
    SCHEME_LIST: '/api/scheme/list',
    SCHEME_SHOW: '/api/scheme/show',
    USER_SHOW: '/api/user/show',
    PACKAGES: '/api/packages',
    PACKAGE_PREVIEW: '/api/packages',
    REPORTS: '/api/reports',
    ALARMS: '/api/alarms',
    SUMMARIES: '/api/summaries',
    MINUTE_REPORTS: '/api/minute-reports',
    CONFIGS: '/api/configs',
    STATISTICS: '/api/statistics',
    CHART_DEVIATION_SETTINGS: '/api/chart-deviation-settings',
    ERROR: '/api/error/',
    GATEWAY_SHOW: '/api/gateway/show',
    WATERPIPE: '/api/waterpipe',
    WATERPIPES: '/api/waterpipes',
    WATERPIPE_ADD: '/api/waterpipe/add',
    WATERPIPE_EDIT: '/api/waterpipe/edit',
    WATERPIPE_DELETE: '/api/waterpipe/delete',
    LIVE_CHECK: '/api/live-check',
    PROTOCOLS_SHOW: '/api/protocols/show',
    PRODUCTION_REPORT: '/api/reports/production-report',
    TEST_REPORT: '/api/reports/test-report',
    TEST_REPORT_V2_INDEX: '/api/reports/test-report/v2/index',
    TEST_REPORT_V2_GET: '/api/reports/test-report/v2/get',
    TEST_REPORT_V2_CREATE: '/api/reports/test-report/v2/create',
    TEST_REPORT_V2_DELETE: '/api/reports/test-report/v2/delete',
    DECRYPT_PACKAGE: '/api/decrypt-package',
    ENCRYPT_PACKAGE: '/api/encrypt-package',
    TEST_PACKAGE: '/api/testPackage',
    LIST_TEMPLATE_INDEX: '/api/list-template/index',
    LIST_TEMPLATE_SHOW: '/api/list-template/show',
    LIST_TEMPLATE_CREATE: '/api/list-template/create',
    LIST_TEMPLATE_UPDATE: '/api/list-template/update',
    LIST_TEMPLATE_DELETE: '/api/list-template/delete',
    SERIAL_NUMBERS_SHOW: '/api/serial-numbers/show',
    FW_TASKS: '/api/fw-tasks',
    FW_APNS: '/api/fw-apns',
    FW_FILES: '/api/fw-files',
    FW_LOGS: '/api/fw-logs',
    FW_SETTINGS: '/api/fw-settings',
    FW_PAIRS: '/api/fw-pairs',
    FW_READ_MODEL: '/api/fw-read-model',
};

export const fwTaskType = {
    PRONAQUA: 1,
    LORA: 2,
};

export const fwTaskStatus = {
    ACTIVE: 1,
    COMPLETED: 2,
    CANCELLED: 3,
    PAUSED: 4,
};

export const fwDeviceStatus = {
    PENDING: 1,
    COMMAND_SENT: 2,
    COMMAND_RECEIVED: 3,
    DEVICE_CONNECTED: 4,
    COMPLETED: 5,
    FAILED: 6,
    EXCLUDED: 7,
};

export const fwTaskStatusByString = {
    active: 1,
    finished: 2,
    cancelled: 3,
    paused: 4,
};

export const fwTaskStatusLabels = {
    [fwTaskStatus.ACTIVE]: 'Aktywne',
    [fwTaskStatus.COMPLETED]: 'Zakończone',
    [fwTaskStatus.CANCELLED]: 'Anulowane',
    [fwTaskStatus.PAUSED]: 'Pauza',
};

export const fwTaskStatusValue = status =>
    typeof status === 'number' ? status : fwTaskStatusByString[status];

export const fwTaskStatusColors = {
    [fwTaskStatus.ACTIVE]: '#1E90FF',
    [fwTaskStatus.COMPLETED]: '#2E7D32',
    [fwTaskStatus.CANCELLED]: '#9E9E9E',
    [fwTaskStatus.PAUSED]: '#FFB300',
};

export const fwTaskTypeLabels = {
    [fwTaskType.PRONAQUA]: 'PronAqua',
    [fwTaskType.LORA]: 'Koncentrator',
};

export const fwDeviceStatusLabels = {
    [fwDeviceStatus.PENDING]: 'Oczekujące',
    [fwDeviceStatus.COMMAND_SENT]: 'Ustawiony rozkaz',
    [fwDeviceStatus.COMMAND_RECEIVED]: 'Rozkaz pobrany',
    [fwDeviceStatus.DEVICE_CONNECTED]: 'Urządzenie zgłoszone',
    [fwDeviceStatus.COMPLETED]: 'Zakończone',
    [fwDeviceStatus.FAILED]: 'Błąd',
    [fwDeviceStatus.EXCLUDED]: 'Wykluczone',
};

export const fwDeviceStatusColors = {
    [fwDeviceStatus.PENDING]: '#000000',
    [fwDeviceStatus.COMMAND_SENT]: '#1E90FF',
    [fwDeviceStatus.COMMAND_RECEIVED]: '#FFB300',
    [fwDeviceStatus.DEVICE_CONNECTED]: '#FF6D00',
    [fwDeviceStatus.COMPLETED]: '#2E7D32',
    [fwDeviceStatus.FAILED]: '#D32F2F',
    [fwDeviceStatus.EXCLUDED]: '#D32F2F',
};

export const fwSettingsFields = [
    {
        name: 'same_sign_limit',
        label: 'Maksymalna liczba dopuszczeń dla jednego znaku rozdzielnicy',
        min: 1,
        max: 9999,
    },
    {
        name: 'max_command_pickups',
        label: 'Maksymalna liczba powtórzeń zleceń wymiany FW',
        min: 1,
        max: 4294967295,
    },
    {
        name: 'pickup_connect_seconds',
        label: 'Maksymalny czas od pobrania rozkazu do zgłoszenia się po FW (s)',
        min: 1,
        max: 4294967295,
    },
    {
        name: 'max_exchange_seconds',
        label: 'Maksymalny czas wymiany FW (s)',
        min: 1,
        max: 4294967295,
    },
    {
        name: 'junior_to_pionier_threshold',
        label: 'Ilość prawidłowych pobrań junior → pionier',
        min: 1,
        max: 4294967295,
    },
    {
        name: 'pionier_to_senior_threshold',
        label: 'Ilość prawidłowych pobrań pionier → senior',
        min: 1,
        max: 4294967295,
    },
];

export const fwPairStageLabels = {
    junior: 'Junior',
    pionier: 'Pionier',
    senior: 'Senior',
};

export const fwPairNextStage = {
    junior: 'pionier',
    pionier: 'senior',
    senior: null,
};

export const fwCapabilityReasonLabels = {
    PAM_PROTOCOL_UNCONFIRMED: 'PAM — tylko katalog',
    TRANSFER_FAMILY_UNKNOWN: 'Nieznana rodzina pliku',
    FW_ARTIFACT_UNAVAILABLE: 'Artefakt niedostępny',
    TRANSFER_CAPABILITY_DISABLED: 'Transfer wyłączony',
};

export const fwStartOutcomeLabels = {
    failed: 'Błąd w czasie pobierania FW',
    delivered: 'FW pobrany prawidłowo',
    in_progress: 'W trakcie pobierania',
    open: 'Sesje bez startu',
    installed: 'FW wymieniony',
};

export const fwStartOutcomeRowLabels = {
    failed: 'Błąd',
    delivered: 'FW pobrany prawidłowo',
    in_progress: 'W trakcie pobierania',
    open: 'Bez startu',
    installed: 'FW wymieniony',
};

export const fwStartOutcomeOrder = ['failed', 'delivered', 'installed', 'in_progress', 'open'];

export const fwEndpointStatusLabels = {
    command_set: 'Ustawiony rozkaz',
    command_picked_up: 'Rozkaz pobrany',
    transfer_in_progress: 'W trakcie pobierania',
    fw_delivered: 'FW pobrany prawidłowo',
    fw_replaced: 'FW wymieniony',
    packet_retry_exhausted: 'Błąd w czasie pobierania FW - przekroczona liczba powtórek wysłania pakietu',
    exchange_timeout: 'Błąd w czasie pobierania FW - przekroczony timeout wysyłania całego FW',
    connection_closed: 'Błąd w czasie pobierania FW - zakończenie połączenia przez urządzenie',
    immature_revision: 'Błąd w czasie pobierania FW - niedojrzała rewizja',
    revision_not_allowed: 'Błąd w czasie pobierania FW - brak dozwolonych rewizji',
    task_revision_restricted: 'Błąd w czasie pobierania FW - rewizja wykluczona przez zadanie',
    failed_other: 'Błąd w czasie pobierania FW - inny błąd',
    excluded: 'Wykluczone',
    awaiting_command: 'Oczekuje na rozkaz',
    unknown: 'Stan nieznany',
};

export const fwEndpointStatusColors = {
    command_set: '#1E90FF',
    command_picked_up: '#FFB300',
    transfer_in_progress: '#FF6D00',
    fw_delivered: '#2E7D32',
    fw_replaced: '#2E7D32',
    packet_retry_exhausted: '#D32F2F',
    exchange_timeout: '#D32F2F',
    connection_closed: '#D32F2F',
    immature_revision: '#D32F2F',
    revision_not_allowed: '#D32F2F',
    task_revision_restricted: '#D32F2F',
    failed_other: '#D32F2F',
    excluded: '#D32F2F',
    awaiting_command: '#000000',
    unknown: '#757575',
};

export const fwArtifactFamilies = ['PAQ', 'PAC', 'PAM'];

export const fwProvenanceKindLabels = {
    operator_declared: 'Zadeklarowana przez operatora',
    device_vendor_supplied: 'Od dostawcy urządzenia',
};

export const fwRefusalLabels = {
    FW_INVALID_INPUT: 'Nieprawidłowe dane',
    FW_UNKNOWN_SETTING: 'Nieznane ustawienie',
    FW_INTEGER_REQUIRED: 'Wartość musi być liczbą całkowitą',
    FW_OPERATION_KEY_REQUIRED: 'Brak klucza operacji',
    FW_VERSION_CONFLICT: 'Dane zmieniły się w innym miejscu',
    FW_IDEMPOTENCY_CONFLICT: 'Ta operacja została już wykonana z innym zestawem danych',
    FW_INVALID_ARTIFACT: 'Nieprawidłowy plik — sprawdź nazwę, rozmiar i rodzinę',
    FW_INVALID_REVISION: 'Rewizja musi mieć 1 do 16 bajtów w zapisie szesnastkowym',
    FW_ARTIFACT_UNAVAILABLE: 'Artefakt jest wycofany lub niedostępny',
    FW_ARTIFACT_NOT_FOUND: 'Nie znaleziono artefaktu',
    FW_AUTOMATION_DISABLED: 'Moduł FW jest wyłączony',
    FW_SETTINGS_NOT_PROVISIONED: 'Konfiguracja nie została jeszcze opublikowana',
    FW_SETTINGS_INVALID: 'Opublikowana konfiguracja jest nieprawidłowa',
    FW_OPERATION_UNAVAILABLE: 'Operacja chwilowo niedostępna',
    FW_COUNTER_DRIFT: 'Liczniki artefaktu nie zgadzają się',
};

export const inputField = {
    FROM: 'from',
    TO: 'to',
};

export const localStorageMode = {
    SET_ITEM: 'setItem',
    GET_ITEM: 'getItem',
    REMOVE_ITEM: 'removeItem',
};

export const localStorageKey = {
    USER_ID: 'userId',
    USER_ROLE: 'userRole',
    USER_PERMISSIONS: 'userPermissions',
    USER_IS_EXTERNAL: 'userIsExternal',
    HEADER: 'header',
    COMMUNICATOR_RANGE_FROM_VALUE: 'communicatorRangeFromValue',
    COMMUNICATOR_RANGE_TO_VALUE: 'communicatorRangeToValue',
    LISTS_SELECTED_WATERPIPE_NAME: 'listsSelectedWaterpipeName',
    GENERATED_TEST_LIST_DATA: 'generatedTestListData',
    GENERATED_TEST_LIST_DATA_V2: 'generatedTestListDataV2',
    GENERATED_PROD_LIST_DATA: 'generatedProdListData',
    COLUMNS_SETTINGS: 'columnsSettings',
    SELECTED_PACKAGE_COMMUNICATOR: 'selectedPackageCommunicator',
    SELECTED_PACKAGE_ID: 'selectedPackageId',
    WATERPIPES_LIST: 'waterpipesList',
    NUMBERS_LIST: 'numbersList',
    PAGINATION_SIZE_TEST_LIST: 'paginationSizeTestList',
    COLUMNS_DEFS_TEST_LIST: 'columnsDefsTestList',
    COLUMN_DEFS_TABLE_REPORTS: 'columnDefsTableReports',
    COLUMN_DEFS_TABLE_ALARMS: 'columnDefsTableAlarms',
    COLUMN_DEFS_TABLE_SUMMARY: 'columnDefsTableSummary',
    COLUMN_DEFS_TABLE_MINUTE_REPORTS: 'columnDefsTableMinuteReports',
    COLUMN_DEFS_TABLE_CONFIG_REPORTS: 'columnDefsTableConfigReports',
    COLUMN_DEFS_TABLE_CON_MAPS: 'columnDefsTableConMaps',
    COLUMN_DEFS_TABLE_CON_CONFIGS: 'columnDefsTableConConfigs',
    COLUMN_DEFS_TABLE_MULTI_LOGGER_IMPULSE: 'columnDefsTableMultiLoggerImpulse',
    DOCS_REPORT_TYPE: 'docsReportType',
    FAVORITE_REPORT_EDITED: 'favoriteReportEdited',
    LIST_TEMPLATES_COLUMN_STATE: 'listTemplatesColumnState',
    PAGINATION_SIZE_TABLE_REPORTS: 'paginationSizeTableReports',
    DOCS_SEARCH_COMMUNICATOR: 'docsSearchCommunicator',
    DOCS_SEARCH_PACKAGE_ID: 'docsSearchPackageId',
    DOCS_PAGE: 'docsPage',
    CURRENT_URL: 'currentUrl',
    PIPELINE_LIST_SEARCH: 'pipelinesListSearch',
    PACKAGES_PAGE: 'packagesPage',
    PACKAGES_SEARCH_ID: 'packagesSearchId',
    PACKAGES_SEARCH_SMS: 'packagesSearchSms',
    PACKAGES_SEARCH_DOK: 'packagesSearchDok',
    PACKAGES_SEARCH_DOK_NAME: 'packagesSearchDokName',
    PACKAGES_SEARCH_SIM: 'packagesSearchSim',
    PACKAGES_SEARCH_COM: 'packagesSearchCom',
    PACKAGES_SEARCH_PHRASE: 'packagesSearchPhrase',
    PACKAGES_SELECTED_WATERPIPE: 'packagesSelectedWaterpipe',
    PACKAGES_SELECTED_WATERPIPE_NAME: 'packagesSelectedWaterpipeName',
    PACKAGES_SELECTED_STATUS: 'packagesSelectedStatus',
    PACKAGES_SELECTED_STATUS_NAME: 'packagesSelectedStatusName',
    PACKAGES_SELECTED_PROTOCOL: 'packagesSelectedProtocol',
    PACKAGES_SELECTED_PROTOCOL_NAME: 'packagesSelectedProtocolName',
    PARSER_ERROR_PACKAGE_DATA: 'parserErrorPackageData',
    PARSER_ERROR_PACKAGE_DATE_CREATED: 'parserErrorPackageDateCreated',
    IS_SHOW_ONLY_OFFLINE_CHECKED: 'isShowOnlyOfflineChecked',
    IS_PARSER_ERROR_LINK_CLICKED: 'isParserErrorLinkClicked',
    IS_DUPLICATE_CHECKED: 'isDuplicateChecked',
    PAGINATION_SIZE_SERIAL_NUMBERS: 'paginationSizeSerialNumbers',
    COLUMNS_DEFS_SERIAL_NUMBERS: 'columnsDefsSerialNumbers',
    PREVIEW_SEARCH_COMMUNICATOR: 'previewSearchCommunicator',
    PREVIEW_PAGE: 'previewPage',
};

export const sessionStorageKey = {
    SELECTED_PACKAGE_COMMUNICATOR: 'selectedPackageCommunicator',
    SELECTED_PACKAGE_ID: 'selectedPackageId',
    IS_USER_ENTERED_FROM_PACKAGES_LINK: 'isUserEnteredFromPackagesLink',
};

export const docsSearchValue = {
    COMMUNICATOR: 'searchCommunicator',
    PACKAGE_ID: 'searchPackageId',
};

export const communicatorFieldType = {
    COMMUNICATORS_LIST: 'communicatorsList',
    COMMUNICATORS_RANGE: 'communicatorsRange',
};

export const communicatorsType = {
    COMMUNICATOR: 'communicator',
    COUPLED_COMMUNICATOR: 'coupledCommunicator',
    CONCENTRATOR: 'concentrator',
};

export const communicatorsTypePl = {
    COMMUNICATOR: 'Komunikator',
    COUPLED_COMMUNICATOR: 'Komunikator sprzężony',
    CONCENTRATOR: 'Koncentrator',
};

export const communicatorsChannel = {
    BOTH: '1 + 2',
    ONE: '1',
    TWO: '2',
};

export const tabHeadToSymbols = {
    ordinal_number: 'LP',
    tab_1: '\u2587\u2587\u2587',
    tab_2: '\u2587\u2587\u2587',
    tab_3: '\u2587\u2587\u2587',
    tab_4: '\u2587\u2587\u2587',
    tab_5: '\u2587\u2587\u2587',
    date_ordered: 'Data zamówienia',
    date_finished: 'Data zakończenia',
    name: 'Nazwa zestawienia',
    date_from: 'Data od',
    date_to: 'Data do',
    numbers: 'Numery',
    channel: 'Kanał',
    show: 'Pokaż',
    delete: 'Usuń',
    waterpipe: 'Wodociąg',

    report_package_id: 'ZD1',
    report_communicator: 'ZD4',
    report_gsm_channel: 'ZG1',
    report_used: 'ZI8',
    report_firmware: 'ZI9',
    report_recipient: 'ZD9',
    report_gsm_level_first: 'ZG4',
    report_gsm_count_starts: 'ZG5',
    report_gsm_count_communications: 'ZG6',
    report_gsm_buffer: 'ZG2',
    report_gsm_buffer_all: 'ZG14',
    report_gsm_uptime: 'ZG7',
    report_radio_battery: 'ZR1',
    report_battery: 'ZI1',
    report_temperature: 'ZI3',
    report_quality: 'ZD7',
    report_learning: 'ZI4',
    report_inductor_1_quality: 'ZI5',
    report_inductor_2_quality: 'ZI6',
    report_inductor_3_quality: 'ZI7',
    report_alert_mechanic_count: 'ZA2',
    report_alert_mechanic_duration: 'ZA3',
    report_alert_mechanic_prealerts: 'ZA1',
    report_alert_magnetic_count: 'ZA5',
    report_alert_magnetic_duration: 'ZA6',
    report_alert_magnetic_prealert: 'ZA4',
    report_config_statuses: 'ZS2',
    report_debug_statuses: 'ZS3',
    report_debug_reset_time: 'ZS4',
    report_lte_bts_band: 'ZS6',

    alarm_id: 'LP',
    alarm_communicator: 'AD4/ZD4',
    alarm_received_at: 'AD2',
    alarm_date: 'AD3',
    alarm_gsm_level: 'AG3',
    alarm_used: 'AI9',
    alarm_firmware: 'AI10',
    alarm_recipient: 'AD7',
    alarm_voltage: 'AI2',
    report_received_at: 'ZD2',
    report_date: 'ZD3',
    report_channel: 'ZD8',
    report_voltage: 'ZI2',
    report_radio_signal_strength: 'ZR6',
    report_gsm_level: 'ZG3',
    report_readings: 'ZD5',
    report_sabotage: 'ZD6',
    report_cpu_activity: 'ZD10',
    report_plus: '+',
    report_minus: '-',
    report_m: 'm',
    report_M: 'M',
    report_g: 'g',
    report_G: 'G',
    report_d: 'd',
    report_D: 'D',
    parser_error: 'Błąd parsera',

    id: 'ID',
    created_at: 'Data utworzenia',
    updated_at: 'Data aktualizacji',
    number: 'Numer',
    sign: 'Znak rozdzielnicy',
    symbol: 'Symbol',
    first_report_at: 'Data pierwszego raportu',
    firmware: 'Wersja firmware',
    waterworks_number: 'NKW',
    apn: 'APN',
};

export const tabHeadToSymbolsToTitles = {
    alarm_id: 'LP',
    alarm_communicator: 'NR. K',
    alarm_received_at: 'DATA DOSTARCZENIA NA SERWER',
    alarm_date: 'DATA WYGENEROWANIA',
    alarm_gsm_level: 'POZIOM SYGNAŁU ',
    alarm_used: 'TYP ANTENY/PRZEZNACZENIE',
    alarm_firmware: 'FIRMWARE',
    alarm_recipient: 'ODBIORCA',
    alarm_voltage: 'NAPĘCIE',
    report_received_at: 'DATA DOSTARCZENIA NA SERWER',
    report_date: 'DATA WYGENEROWANIA',
    report_channel: 'KANAŁ',
    report_voltage: 'NAPIĘCIE',
    report_radio_signal_strength: 'SYGNAŁ RADIOWY W PRZYPADKU IMPULSATORA',
    report_gsm_level: 'SYGNAŁ GSM',
    report_readings: 'ODCZYTY',
    report_sabotage: 'SABOTAŻ',
    report_cpu_activity: 'Zajętość procesora',
    report_plus: '+',
    report_minus: '-',
    report_m: 'm',
    report_M: 'M',
    report_g: 'g',
    report_G: 'G',
    report_d: 'd',
    report_D: 'D',
    parser_error: 'Błąd parsera',

    ordinal_number: 'Liczba porządkowa',
    tab_1: '',
    tab_2: '',
    tab_3: '',
    tab_4: '',
    tab_5: '',

    report_package_id: 'ID',
    report_communicator: 'Numer seryjny urządzenia',
    report_gsm_channel: 'Nr kanału transmisyjnego',
    report_used: 'Rodzaj anteny / Przeznaczenie',
    report_firmware: 'Firmware ID',
    report_recipient: 'Numer odbiorcy - klienta',
    report_gsm_level_first: 'Poziom GSM przy pierwszej próbie wysłania bieżącego raportu',
    report_gsm_count_starts: 'Licznik sesji GSM',
    report_gsm_count_communications: 'Ilość poprawnych komunikacji przez moduł GSM/LTE',
    report_gsm_buffer: 'Ilość raportów w buforze bez raportów minutowych',
    report_gsm_buffer_all: 'Ilość raportów minutowych w buforze',
    report_gsm_uptime:
        'Zużycie prądu przez moduł GSM/LTE [mAh] / Czas włączenia modułu GSM/LTE przy zasilaniu bateryjnym[min]',
    report_radio_battery: 'Energia zużyta przez nadajnik [mAh]',
    report_battery: 'Stan baterii [%]',
    report_temperature: 'Temperatura [°C]',
    report_quality: 'Licznik przepływu wstecznego [impuls]',
    report_learning: 'Stan „uczenie się"',
    report_inductor_1_quality: 'Jakość sygnału cewki 1',
    report_inductor_2_quality: 'Jakość sygnału cewki 2',
    report_inductor_3_quality: 'Jakość sygnału cewki 3',
    report_alert_mechanic_count: 'Dobowy Licznik ilości sabotażu mechanicznego',
    report_alert_mechanic_duration: 'Łączny czas trwania sabotażu mech.o [s]. max 194 dni',
    report_alert_mechanic_prealerts: 'Ilość prealarmów sabotażu mechanicznego',
    report_alert_magnetic_count: 'Dobowy Licznik ilości sabotażu magnetycznego',
    report_alert_magnetic_duration: 'Łączny czas trwania sabotażu magnet. [s], max 194 dni',
    report_alert_magnetic_prealert: 'Dobowy czas aktywności CPU [%]',
    report_config_statuses: 'Nr pasma LTE (BANDu), ID BTSa / Statusy konfiguracyjne',
    report_debug_statuses: 'Przyczyna resetu procesora',
    report_debug_reset_time: 'Czas od ostatniego resetu procesora [YY/MM(28 dni)/DD HH:MM]',
    report_lte_bts_band: 'ID operatora komórkowego / Pasmo LTE i ID BTSa',

    template_name: 'Nazwa zestawienia',
    template_description: 'Opis zestawienia',
    template_createdAt: 'Data utworzenia',
    template_numbers: 'Numery komunikatorów',
    template_waterpipeName: 'Nazwa wodociągu',
    template_waterpipeSign: 'Znak rozdzielnicy',
    template_channel: 'Kanał',
    template_action: 'Edytuj',

    id: 'ID',
    created_at: 'Data utworzenia',
    updated_at: 'Data aktualizacji',
    number: 'Numer',
    sign: 'Znak rozdzielnicy',
    symbol: 'Symbol',
    first_report_at: 'Data pierwszego raportu',
    firmware: 'Wersja firmware',
    waterworks_number: 'NKW',
    apn: 'APN',
};

export const columnTypes = {
    ORDINAL_NUMBER: 'ordinal_number',
    TAB_1: 'tab_1',
    TAB_2: 'tab_2',
    TAB_3: 'tab_3',
    TAB_4: 'tab_4',
    TAB_5: 'tab_5',
    SHOW: 'show',
    DELETE: 'delete',

    DATE_ORDERED: 'date_ordered',
    DATE_FINISHED: 'date_finished',
    NAME: 'name',
    WATERPIPE: 'waterpipe',
    DATE_FROM: 'date_from',
    DATE_TO: 'date_to',
    NUMBERS: 'numbers',

    REPORT_GSM_LEVEL: 'report_gsm_level',
    REPORT_GSM_LEVEL_FIRST: 'report_gsm_level_first',
    REPORT_GSM_CHANNEL: 'report_gsm_channel',
    REPORT_COMMUNICATOR: 'report_communicator',
    REPORT_READINGS: 'report_readings',
    REPORT_SABOTAGE: 'report_sabotage',
    REPORT_CPU_ACTIVITY: 'report_cpu_activity',
    REPORT_RECEIVED_AT: 'report_received_at',
    REPORT_PLUS: 'report_plus',
    REPORT_MINUS: 'report_minus',
    REPORT_M: 'report_m',
    REPORT_CAPITAL_M: 'report_M',
    REPORT_G: 'report_g',
    REPORT_CAPITAL_G: 'report_G',
    REPORT_D: 'report_d',
    REPORT_CAPITAL_D: 'report_D',
    PARSER_ERROR: 'parser_error',
    REPORT_DEBUG_RESET_TIME: 'report_debug_reset_time',
    REPORT_PACKAGE_ID: 'report_package_id',
    REPORT_DATE: 'report_date',
    REPORT_USED: 'report_used',
    REPORT_FIRMWARE: 'report_firmware',
    REPORT_RECIPIENT: 'report_recipient',
    REPORT_GSM_COUNT_STARTS: 'report_gsm_count_starts',
    REPORT_GSM_COUNT_COMMUNICATIONS: 'report_gsm_count_communications',
    REPORT_GSM_BUFFER: 'report_gsm_buffer',
    REPORT_GSM_BUFFER_ALL: 'report_gsm_buffer_all',
    REPORT_GSM_UPTIME: 'report_gsm_uptime',
    REPORT_RADIO_BATTERY: 'report_radio_battery',
    REPORT_RADIO_SIGNAL_STRENGTH: 'report_radio_signal_strength',
    REPORT_VOLTAGE: 'report_voltage',
    REPORT_BATTERY: 'report_battery',
    REPORT_TEMPERATURE: 'report_temperature',
    REPORT_CHANNEL: 'report_channel',
    REPORT_QUALITY: 'report_quality',
    REPORT_LEARNING: 'report_learning',
    REPORT_INDUCTOR_1_QUALITY: 'report_inductor_1_quality',
    REPORT_INDUCTOR_2_QUALITY: 'report_inductor_2_quality',
    REPORT_INDUCTOR_3_QUALITY: 'report_inductor_3_quality',
    REPORT_ALERT_MECHANIC_COUNT: 'report_alert_mechanic_count',
    REPORT_ALERT_MECHANIC_DURATION: 'report_alert_mechanic_duration',
    REPORT_ALERT_MECHANIC_PREALERTS: 'report_alert_mechanic_prealerts',
    REPORT_ALERT_MAGNETIC_COUNT: 'report_alert_magnetic_count',
    REPORT_ALERT_MAGNETIC_DURATION: 'report_alert_magnetic_duration',
    REPORT_ALERT_MAGNETIC_PREALERT: 'report_alert_magnetic_prealert',
    REPORT_CONFIG_STATUSES: 'report_config_statuses',
    REPORT_DEBUG_STATUSES: 'report_debug_statuses',
    REPORT_LTE_BTS_BAND: 'report_lte_bts_band',

    ALARM_ID: 'alarm_id',
    ALARM_COMMUNICATOR: 'alarm_communicator',
    ALARM_RECEIVED_AT: 'alarm_received_at',
    ALARM_DATE: 'alarm_date',
    ALARM_GSM_LEVEL: 'alarm_gsm_level',
    ALARM_USED: 'alarm_used',
    ALARM_RECIPIENT: 'alarm_recipient',
    ALARM_VOLTAGE: 'alarm_voltage',

    TEMPLATE_ID: 'id',
    TEMPLATE_NAME: 'name',
    TEMPLATE_DESCRIPTION: 'description',
    TEMPLATE_CREATED_AT: 'createdAt',
    TEMPLATE_NUMBERS: 'numbers',
    TEMPLATE_WATERPIPE_NAME: 'waterpipeName',
    TEMPLATE_WATERPIPE_SIGN: 'waterpipeSign',
    TEMPLATE_CHANNEL: 'channel',
    TEMPLATE_ACTION: 'action',
    READINGS: 'readings',
    DEBUG_RESET_TIME: 'debug_reset_time',
    FLOWS: 'flows',
    ALERT_MECHANIC_DURATION: 'alert_mechanic_duration',
    TRANSMITTERS: 'transmitters',
    CHANNEL: 'channel',

    SERIAL_NUMBER_ID: 'id',
    SERIAL_NUMBER_CREATED_AT: 'created_at',
    SERIAL_NUMBER_UPDATED_AT: 'updated_at',
    SERIAL_NUMBER_NUMBER: 'number',
    SERIAL_NUMBER_SIGN: 'sign',
    SERIAL_NUMBER_SYMBOL: 'symbol',
    SERIAL_NUMBER_FIRMWARE: 'firmware',
    SERIAL_NUMBER_WATERWORKS_NUMBER: 'waterworks_number',
    SERIAL_NUMBER_APN: 'apn',
    SERIAL_NUMBER_FIRST_REPORT_AT: 'first_report_at',
};

export const transmittersFields = {
    number: 'number',
    communication_status: 'communication_status',
};

export const tabHeadOrderTestList = [
    columnTypes.ORDINAL_NUMBER,
    columnTypes.REPORT_PACKAGE_ID,
    columnTypes.REPORT_RECEIVED_AT,
    columnTypes.REPORT_DATE,
    columnTypes.REPORT_COMMUNICATOR,
    columnTypes.REPORT_GSM_CHANNEL,
    columnTypes.REPORT_USED,
    columnTypes.REPORT_FIRMWARE,
    columnTypes.REPORT_RECIPIENT,
    columnTypes.REPORT_GSM_LEVEL,
    columnTypes.REPORT_GSM_LEVEL_FIRST,
    columnTypes.REPORT_GSM_COUNT_STARTS,
    columnTypes.REPORT_GSM_COUNT_COMMUNICATIONS,
    columnTypes.REPORT_GSM_BUFFER,
    columnTypes.REPORT_GSM_BUFFER_ALL,
    columnTypes.REPORT_GSM_UPTIME,
    columnTypes.REPORT_RADIO_BATTERY,
    columnTypes.REPORT_VOLTAGE,
    columnTypes.REPORT_BATTERY,
    columnTypes.REPORT_TEMPERATURE,
    columnTypes.REPORT_CHANNEL,
    columnTypes.REPORT_READINGS,
    columnTypes.REPORT_SABOTAGE,
    columnTypes.REPORT_CPU_ACTIVITY,
    columnTypes.REPORT_QUALITY,
    columnTypes.REPORT_LEARNING,
    columnTypes.REPORT_INDUCTOR_1_QUALITY,
    columnTypes.REPORT_INDUCTOR_2_QUALITY,
    columnTypes.REPORT_INDUCTOR_3_QUALITY,
    columnTypes.REPORT_ALERT_MECHANIC_COUNT,
    columnTypes.REPORT_ALERT_MECHANIC_DURATION,
    columnTypes.REPORT_ALERT_MECHANIC_PREALERTS,
    columnTypes.REPORT_ALERT_MAGNETIC_COUNT,
    columnTypes.REPORT_ALERT_MAGNETIC_DURATION,
    columnTypes.REPORT_ALERT_MAGNETIC_PREALERT,
    columnTypes.REPORT_CONFIG_STATUSES,
    columnTypes.REPORT_DEBUG_STATUSES,
    columnTypes.REPORT_DEBUG_RESET_TIME,
    columnTypes.REPORT_LTE_BTS_BAND,
    columnTypes.TAB_1,
    columnTypes.TAB_2,
    columnTypes.TAB_3,
    columnTypes.TAB_4,
    columnTypes.TAB_5,
];

export const tabHeadOrderProdList = [
    columnTypes.ALARM_ID,
    columnTypes.ALARM_COMMUNICATOR,
    columnTypes.ALARM_RECEIVED_AT,
    columnTypes.ALARM_DATE,
    columnTypes.ALARM_GSM_LEVEL,
    columnTypes.ALARM_USED,
    columnTypes.REPORT_FIRMWARE,
    columnTypes.ALARM_RECIPIENT,
    columnTypes.ALARM_VOLTAGE,
    columnTypes.REPORT_RECEIVED_AT,
    columnTypes.REPORT_DATE,
    columnTypes.REPORT_CHANNEL,
    columnTypes.REPORT_VOLTAGE,
    columnTypes.REPORT_RADIO_SIGNAL_STRENGTH,
    columnTypes.REPORT_GSM_LEVEL,
    columnTypes.REPORT_READINGS,
    columnTypes.REPORT_SABOTAGE,
    columnTypes.REPORT_PLUS,
    columnTypes.REPORT_MINUS,
    columnTypes.REPORT_M,
    columnTypes.REPORT_CAPITAL_M,
    columnTypes.REPORT_G,
    columnTypes.REPORT_CAPITAL_G,
    columnTypes.REPORT_D,
    columnTypes.REPORT_CAPITAL_D,
    columnTypes.PARSER_ERROR,
];

export const filterStatusesNoDiacritic = {
    PARSER_ERROR: 'blad parsowania',
    DATE_ERROR: 'blad daty',
    GATEWAY_ERROR: 'blad bramki',
    PIPELINE_ERROR: 'blad wodociagu',
    PROTOCOL_ERROR: 'blad protokolu',
    FINISHED_OFF: 'zakonczone off',
    FINISHED_WITHOUT_OFF: 'zakonczone bez off',
    DECRYPTION_ERROR: 'blad dekodowania',
};

export const filterStatuses = {
    ALL: 'Wszystkie',
    NEW: 'Nowe',
    PENDING: 'Oczekujące',
    FINISHED: 'Zakończone',
    FINISHED_OFF: 'Zakończone OFF',
    FINISHED_WITHOUT_OFF: 'Zakończone bez OFF',
    PARSER_ERROR: 'Błąd parsowania',
    DATE_ERROR: 'Błąd daty',
    GATEWAY_ERROR: 'Błąd bramki',
    PIPELINE_ERROR: 'Błąd wodociągu',
    PROTOCOL_ERROR: 'Błąd protokołu',
    DUPLICATES: 'Duplikaty',
    NOT_PARSED: 'Nieparsowane',
    DECRYPTION_ERROR: 'Błąd dekodowania',
};

/** Package status value (as stored) to its Polish label. */
export const packageStatusLabels = {
    new: 'Nowe',
    pending: 'Oczekujące',
    done: 'Zakończone',
    done_off: 'Zakończone OFF',
    done_wo_off: 'Zakończone bez OFF',
    parser_error: 'Błąd parsowania',
    date_error: 'Błąd daty',
    untrusted_gateway: 'Błąd bramki',
    non_affiliated_waterpipe: 'Błąd wodociągu',
    bad_protocol: 'Błąd protokołu',
    duplicate: 'Duplikaty',
    not_parsed: 'Nieparsowane',
    decrypt_error: 'Błąd dekodowania',
};

export const protocolTypes = {
    V8: 'V8',
    V9: 'V9',
    V10: 'V10',
    V11: 'V11',
    V12: 'V12',
};

export const labels = {
    PASTE_PACKAGE_DATA: 'Wklej treść pakietu',
    PASTE_ENCRYPTED_PACKAGE_DATA: 'Wklej treść zakodowanego pakietu',
};

export const snackbarMsg = {
    PACKAGE_HAS_BEEN_SENT: 'Pakiet został wysłany',
    PACKAGE_HAS_BEEN_DECRYPTED: 'Pakiet został zdekodowany',
    PACKAGE_HAS_BEEN_ENCRYPTED: 'Pakiet został zakodowany',
    TEMPLATE_HAS_BEEN_ADDED: 'Szablon został dodany',
    TEMPLATE_HAS_BEEN_DELETED: 'Szablon został usunięty',
    LIST_TEMPLATE_HAS_BEEN_ADDED: 'Pomyślnie dodano zestawienie do listy ulubionych',
    LIST_TEMPLATE_HAS_BEEN_EDITED: 'Zestawienie zostało pomyślnie edytowane',
    LIST_TEMPLATE_HAS_BEEN_DELETED: 'Zestawienie zostało pomyślnie usunięte',
    TEST_REPORT_GENERATE_SUCCESS: 'Rozpoczęto generowanie zestawienia testowego',
    TEST_REPORT_GENERATE_ERROR: 'Wystąpił błąd podczas generowania zestawienia testowego',
    TEST_LIST_DELETED_SUCCESS: 'Zestawienie testowe zostało pomyślnie usunięte',
    TEST_LIST_DELETED_ERROR: 'Wystąpił błąd podczas usuwania zestawienia testowego',
    ERROR_CONNECTION: 'Wystąpił błąd połączenia z serwerem',
    ERROR: 'Błąd:',
};

export const snackbarVariant = {
    ERROR: 'error',
    SUCCESS: 'success',
};

export const snackbarDefaultValue = {
    isSnackbarOpen: false,
    message: '',
    errorInfo: '',
    variant: '',
};

export const fileExporterTypes = {
    XLS: 'XLS',
    CSV: 'CSV',
    PDF: 'PDF',
};

export const reportTypes = {
    ALL: 'all',
    ALL_PL: 'Wszystkie',
    REPORT: 'report',
    REPORTS: 'reports',
    REPORT_PL: 'Raport',
    REPORTS_PL: 'Raporty',
    ALARM: 'alarm',
    ALARMS: 'alarms',
    ALARM_PL: 'Alarm',
    ALARMS_PL: 'Alarmy',
    SUMMARY: 'summary',
    SUMMARIES: 'summaries',
    SUMMARY_PL: 'Podsumowanie',
    SUMMARIES_PL: 'Podsumowania',
    MINUTE: 'minute',
    MINUTE_REPORTS: 'minute-reports',
    MINUTE_REPORT_PL: 'Raport minutowy',
    MINUTE_REPORTS_PL: 'Raporty minutowe',
    CONFIG: 'config',
    CONFIGS: 'configs',
    CONFIG_PL: 'Raport konfiguracyjny',
    CONFIGS_PL: 'Raporty konfiguracyjne',
    CON_MAP: 'con_map',
    CON_MAPS: 'concentrator-maps',
    CON_MAP_PL: 'Koncentrator mapa',
    CON_MAPS_PL: 'Koncentrator mapy',
    CON_CONFIG: 'con_config',
    CON_CONFIGS: 'concentrator-configs',
    CON_CONFIG_PL: 'Raport konfiguracyjny z koncentratora',
    CON_CONFIGS_PL: 'Raporty konfiguracyjne z koncentratora',
    MULTI_LOGGER_IMPULSE: 'multi_logger_impulse',
    MULTI_LOGGER_IMPULSE_PL: 'Raport z wejścia cyfrowego impulsowego MultiRejestratora',
};

export const fetchStatuses = {
    loading: 'Trwa wczytywanie danych...',
    exporting: 'Trwa eksportowanie...',
    error: 'Wystąpił błąd połączenia z serwerem.',
};

export const selectStrings = {
    noOptionsAvailable: 'Brak opcji do wyświetlenia',
    noOptionsMatchFilter: 'Żadne opcje nie pasują do filtru',
    noValidValue: 'Nowa wartość jest nieprawidłowa',
    clearText: 'Wyczyść',
    openText: 'Otwórz',
    closeText: 'Zamknij',
};

export const historyActions = {
    PUSH: 'PUSH',
    POP: 'POP',
};

export const waterpipesAll = {
    id: 0,
    name: 'Wszystkie',
    sign: '',
};

export const waterpipeWater = {
    name: 'woda',
    sign: '0W',
};

export const columnEventTypes = {
    resize: 'columnResized',
    move: 'columnMoved',
};

/**
 * Package statuses whose cell links to the package document preview. Adding
 * parser_error or another status is a one-line addition.
 */
export const PREVIEW_STATUSES = ['date_error'];

export const packagePreviewStrings = {
    HEADER: 'Podgląd dokumentów',
    PACKAGE_ID: 'ID pakietu',
    BACK: 'Wróć do listy pakietów',
    RERUN: 'Odczytaj ponownie',
    NOT_PREVIEWABLE_TITLE: 'Nie można wyświetlić dokumentów tego pakietu',
    NOT_PREVIEWABLE: 'Tego pakietu nie można podejrzeć.',
    EMPTY: 'Pakiet nie zawiera dokumentów tego typu.',
    NUMBER: 'Numer',
    ERROR_MARKER: '[błąd]',
    VALUE_IN_PACKAGE: 'Wartość w pakiecie',
    VALUE_PARSED: 'Wartość po parsowaniu',
    VALUE_UNKNOWN: '—',
    RAW_PAYLOAD_TITLE: 'Zawartość pakietu',
    RAW_PAYLOAD_LENGTH: 'Długość',
    RAW_PAYLOAD_TRUNCATED: 'skrócono',
};

export const fwStalledCopy = {
    title: 'Zablokowane próby dojrzałości',
    bounds: 'Odczyt obejmuje pierwszych 200 aktywnych par i do 50 prób dla każdej pary. Dalsze pary lub próby mogą nie być widoczne.',
    explanation:
        'Zwolnienie próby usuwa oczekiwanie blokujące postęp pary. Nie jest potwierdzeniem instalacji ani zakończeniem transferu.',
    empty: 'Brak zablokowanych prób w tym oknie odczytu.',
    reload: 'Odczytaj stan ponownie',
    release: 'Zwolnij próbę',
    confirm: 'Potwierdź zwolnienie',
    cancel: 'Anuluj',
    candidate: 'Próba',
    reason: 'Powód zwolnienia',
    reasonHint: 'Wymagany powód: maksymalnie 512 bajtów UTF-8.',
    choose: 'Wybierz próbę',
    unknownAge: 'Wiek nieznany',
    success: 'Próba została zwolniona.',
    readError: 'Nie można odczytać zablokowanych prób.',
    invalidRead: 'Nieprawidłowa odpowiedź listy prób.',
    uncertain:
        'Wynik operacji jest niepewny. Mogła zostać wykonana. Ponów tę samą operację albo odczytaj stan ponownie przed nowym wyborem.',
    retry: 'Ponów tę samą operację',
    unknownResult: 'Nieznany wynik operacji. Odczytaj stan ponownie przed nowym wyborem.',
    refused: 'Operacja nie została potwierdzona. Odczytaj stan ponownie przed nowym wyborem.',
    unavailable: 'Brak prawidłowych kandydatów',
    pair: 'Para',
    stage: 'Etap',
    epoch: 'Epoka etapu',
    confirmed: 'Potwierdzone sukcesy',
    outstanding: 'Nierozstrzygnięte próby',
    threshold: 'Próg',
    revision: 'Wersja progu',
    age: 'Najstarsza próba',
    version: 'Wersja próby',
    seconds: 's',
    reasons: {
        ALREADY_RELEASED: 'Próba była już zwolniona.',
        TRIAL_NOT_OUTSTANDING: 'Próba nie oczekuje na zwolnienie.',
        TRIAL_EPOCH_STALE: 'Próba pochodzi z poprzedniej epoki.',
        RELEASE_PAIR_MISMATCH: 'Próba nie należy do wybranej pary.',
        ATTEMPT_NOT_FOUND: 'Nie znaleziono próby.',
        INVALID_REASON: 'Nieprawidłowy powód zwolnienia.',
        INVALID_IDENTIFIER: 'Nieprawidłowy identyfikator lub wersja próby.',
    },
};

export const fwEndpointBoardCopy = {
    title: 'Lista numerów seryjnych zadania',
    readError: 'Nie można odczytać listy numerów seryjnych zadania.',
    truncated: 'Lista numerów seryjnych zadania jest ograniczona do 200; pokazano',
    notRecorded: 'nie zapisano',
    columns: {
        serial: 'Numer seryjny',
        status: 'Status Endpointa',
        sign: 'Znak rozdzielnicy',
        route: 'Połączenie (APN / IP:port)',
        source: 'Rewizja przed wymianą FW',
        target: 'Rewizja docelowa',
        pickup: 'Licznik pobrań rozkazu',
        connection: 'Licznik zgłoszeń do Modułu TCP',
    },
};

export const fwSignActivityCopy = {
    title: 'Listy dynamiczne',
    pageTitle: 'Listy dynamiczne znaku rozdzielnicy',
    explanation:
        'Pomocnicze listy dynamiczne dla wybranego znaku rozdzielnicy: urządzenia aktualnie pobierające FW oraz urządzenia, które pobrały rozkaz wymiany FW. Odczyt nie zmienia żadnych danych.',
    bounds: 'Każda lista obejmuje najwyżej 200 pozycji; komunikat podaje, gdy w oknie są dalsze pozycje.',
    signLabel: 'Znak rozdzielnicy',
    signRequired: 'Podaj znak rozdzielnicy.',
    show: 'Pokaż',
    reload: 'Odczytaj ponownie',
    readError: 'Nie można odczytać list dynamicznych znaku rozdzielnicy.',
    empty: 'Brak urządzeń dla tego znaku w oknie odczytu.',
    truncated: 'Lista pokazuje najwyżej 200 pozycji — w oknie są dalsze.',
    activeTitle: 'Lista urządzeń, które aktualnie pobierają FW',
    pickupTitle: 'Lista urządzeń, które pobrały rozkaz wymiany FW',
    activeEmpty: 'Brak urządzeń aktualnie pobierających FW.',
    pickupEmpty: 'Brak urządzeń, które pobrały rozkaz wymiany FW.',
    notRecorded: 'nie zapisano',
    columns: {
        serial: 'Numer seryjny',
        task: 'Zadanie',
        taskName: 'Nazwa zadania',
        attempt: 'Próba',
        command: 'Rozkaz pobrania FW',
        activeEventAt: 'Czas zgłoszenia się po FW (UTC)',
        pickupEventAt: 'Czas pobrania rozkazu (UTC)',
    },
};

export const fwReleaseCopy = {
    title: 'Audyt zwolnień',
    explanation:
        'Zestawienie ręcznych zwolnień prób zarejestrowanych przez backend. Odczyt nie zmienia par, prób ani transferów.',
    bounds: 'Odczyt obejmuje najnowsze 200 zwolnień, od najnowszego.',
    truncated: 'W oknie odczytu są dalsze zwolnienia — lista pokazuje najnowsze 200.',
    empty: 'Brak ręcznych zwolnień w tym oknie odczytu.',
    readError: 'Nie można odczytać zwolnień.',
    reload: 'Odczytaj ponownie',
    notRecorded: 'nie zapisano',
    columns: {
        releasedAt: 'Zwolniono (UTC)',
        artifact: 'Plik',
        pair: 'Para',
        attempt: 'Próba',
        serial: 'Numer seryjny',
        stage: 'Aktualny etap pary',
        operator: 'Operator',
        reason: 'Powód',
    },
};

export const fwPromotionCopy = {
    loading: 'Odczytywanie konfiguracji i źródeł…',
    action: 'Promuj do ',
    confirm: 'Potwierdź promocję',
    cancel: 'Anuluj promocję',
    reload: 'Odśwież źródła',
    retry: 'Ponów tę samą promocję',
    success: 'Para została promowana.',
    bounds: 'Lista obejmuje pierwszych 20 źródeł artefaktu. Dalsze źródła mogą nie być widoczne.',
    effect: 'Nowa epoka rozpocznie się z wyzerowanymi licznikami potwierdzeń i prób w toku. Promocja nie uruchamia transferu firmware.',
    uncertain:
        'Wynik promocji jest niepewny. Mogła zostać wykonana. Ponów tę samą promocję lub odśwież stan przed nowym wyborem. Zamknięcie usuwa lokalną możliwość ponowienia.',
    reloadRequired: 'Odśwież źródła i potwierdź ponownie przed kolejną operacją.',
    unknown: 'Nieznany wynik promocji. Odśwież stan przed nowym wyborem.',
    readError: 'Nie można odczytać źródeł artefaktu',
    invalid: 'Dane pary lub konfiguracji są nieprawidłowe — promocja niedostępna.',
    terminal: 'Senior to najwyższy etap — brak dalszej promocji.',
    retired: 'źródło wycofane — promocja go nie dotyczy.',
    missingThreshold: 'próg nie jest dostępny w opublikowanej konfiguracji',
    below: 'próg niespełniony',
    thresholdMet: 'próg spełniony',
    source: 'Źródło',
    pair: 'Para',
    version: 'Wersja',
    epoch: 'Epoka',
    threshold: 'Próg',
    confirmed: 'potwierdzone',
    outstanding: 'w toku',
    progress: 'Promocja na etap ',
    thresholdCount: 'potwierdzeń',
    reasons: {
        PAIR_RETIRED: 'Para została wycofana.',
        STAGE_ORDER_INVALID: 'Etap pary zmienił się lub przejście jest niedozwolone.',
        THRESHOLD_NOT_MET: 'Bieżący próg potwierdzeń nie został osiągnięty.',
        TRIALS_OUTSTANDING: 'Para nadal ma próby w toku.',
        PAIR_NOT_FOUND: 'Nie znaleziono pary.',
        INVALID_IDENTIFIER: 'Nieprawidłowy identyfikator lub wersja pary.',
        INVALID_STAGE: 'Nieprawidłowy etap promocji.',
    },
};

export const fwTaskControlCopy = {
    pause: 'Wstrzymaj zadanie',
    resume: 'Wznów zadanie',
    confirmPause: 'Potwierdź pauzę',
    confirmResume: 'Potwierdź wznowienie',
    paused: 'Zapisano pauzę zadania.',
    resumed: 'Zapisano wznowienie zadania z nowym cyklem limitu.',
    pauseEffect:
        'Pauza zachowuje cykl, historię i przypisanie numerów. Nie przerywa trwających transferów ani nie anuluje poleceń już wysłanych do urządzeń.',
    resumeEffect:
        'Wznowienie zamknie poprzedni cykl i otworzy nowy z wybranym limitem pobrań FW. Nie potwierdza transferu ani instalacji firmware. Zadanie może ponownie wyczerpać limit.',
    cycleIdentity: 'Bieżący cykl',
    allowance: 'Nowy limit pobrań FW',
    population: 'Liczba urządzeń zadania',
    allowanceHint: 'Limit dotyczy startów prób, a nie potwierdzonych instalacji.',
    allowanceInvalid: 'Podaj liczbę całkowitą od 1 do liczby urządzeń zadania.',
    cycleUnavailable:
        'Nie można potwierdzić bieżącego cyklu zadania. Odczytaj zadanie ponownie przed pauzą lub wznowieniem.',
    populationUnavailable:
        'Nie można ustalić dodatniej liczby urządzeń zadania. Odczytaj zadanie ponownie przed wznowieniem.',

    finish: 'Zakończ zadanie',
    retire: 'Wycofaj zadanie',
    confirmFinish: 'Potwierdź zakończenie',
    confirmRetire: 'Potwierdź wycofanie',
    cancel: 'Anuluj',
    close: 'Zamknij',
    reload: 'Odczytaj zadanie ponownie',
    retry: 'Ponów tę samą operację',
    back: 'Wróć do zadań',
    finished: 'Zadanie zakończone.',
    retired: 'Zadanie wycofane. Historia została zachowana.',
    finishEffect:
        'Zakończenie zamknie limit zadania i nowe prace. Nie przerywa trwających transferów ani nie potwierdza instalacji firmware.',
    retireEffect: 'Wycofanie ukryje zadanie w zwykłych widokach. Nie usuwa historii zadania.',
    identity: 'Zadanie',
    name: 'Nazwa',
    status: 'Status',
    version: 'Wersja',
    invalid: 'Dane zadania nie pasują do wybranego kontraktu lub trasy. Odczytaj stan ponownie.',
    readError: 'Nie można odczytać zadania.',
    missing:
        'Zadanie jest niedostępne lub zostało wycofane. Brak odczytu nie potwierdza wykonania tej operacji.',
    unknown: 'Nieznany wynik operacji. Odczytaj zadanie ponownie przed kolejnym wyborem.',
    uncertain:
        'Wynik operacji jest niepewny. Mogła zostać wykonana. Ponów tę samą operację albo odczytaj stan ponownie. Zamknięcie usuwa lokalną możliwość ponowienia.',
    reloadRequired: 'Odczytaj zadanie ponownie i potwierdź nowy wybór.',
    taskNotFound: 'Nie znaleziono zadania.',
};

export const fwTaskCreationCopy = {
    title: 'Moduł FW — Nowe zadanie',
    loading: 'Sprawdzanie kontraktu tworzenia zadania…',
    probeError: 'Nie można potwierdzić dostępności tworzenia zadania.',
    reload: 'Wczytaj ponownie',
    refresh: 'Odśwież wybór plików i APN',
    windows: 'Wybór obejmuje pierwsze 20 plików i pierwsze 200 APN. To nie jest pełny katalog.',
    filesError: 'Nie można odczytać wyboru plików firmware.',
    apnsError: 'Nie można odczytać APN. Nadal możesz wybrać połączenie automatyczne.',
    name: 'Nazwa zadania',
    file: 'Plik .bin',
    noFiles: 'Brak plików w odczytanym wyborze',
    unavailable: 'Niedostępny do transferu',
    family: 'Typ urządzenia',
    apn: 'Połączenie',
    automatic: 'Automatycznie z numeru seryjnego',
    routing:
        'Automatyczny wybór korzysta z adresu urządzenia. Wybrany APN obowiązuje wszystkie urządzenia zadania.',
    serials: 'Numery seryjne',
    import: 'Wczytaj plik tekstowy',
    importError: 'Nie można odczytać pliku z numerami.',
    serialHint:
        'Osiem znaków szesnastkowych; maksymalnie 10000 numerów. Linie, przecinki lub średniki. Bez nagłówka.',
    quota: 'Maksymalna liczba pobrań FW w pierwszym cyklu',
    quotaHint:
        'Podaj liczbę od 1 do liczby numerów. Limit dotyczy startów prób, a nie potwierdzonych instalacji.',
    restriction: 'Restrykcje rewizji',
    none: 'Brak',
    allow: 'Tylko urządzenia z rewizją',
    deny: 'Tylko urządzenia BEZ rewizji',
    revisions: 'Lista rewizji',
    revisionHint: 'Zapis szesnastkowy: od 2 do 32 znaków, parzysta długość; maksymalnie 1000 rewizji.',
    create: 'Utwórz zadanie',
    confirmTitle: 'Potwierdzenie utworzenia zadania',
    confirm: 'Potwierdź utworzenie',
    cancel: 'Anuluj',
    effect: 'Utworzenie zapisuje aktywne zadanie i pierwszy cykl limitu. Nie potwierdza transferu ani instalacji firmware.',
    serialCount: 'Liczba numerów',
    sending: 'Zapisywanie zadania…',
    uncertain:
        'Nie wiadomo, czy zadanie zostało zapisane. Ponów wyłącznie tę samą operację albo świadomie wróć do edycji.',
    retry: 'Ponów tę samą operację',
    edit: 'Wróć do edycji jako nowa operacja',
    abandonTitle: 'Powrót do edycji po niepotwierdzonej operacji',
    abandonWarning:
        'Zadanie mogło już powstać. Nowa operacja może utworzyć kolejne zadanie. Powrót ani odświeżenie nie potwierdzają braku poprzedniego zadania.',
    abandonConfirm: 'Rozumiem ryzyko — wróć do edycji',
    unknown:
        'Nie potwierdzono wyniku tworzenia. Nie ponawiaj nieznanej odpowiedzi; sprawdź zadania przed nową operacją.',
    refused: 'Zadanie nie zostało utworzone.',
    invalidName: 'Podaj nazwę o długości od 1 do 255 znaków.',
    invalidFile: 'Wybierz dostępny plik PAQ lub PAC z odczytanego wyboru.',
    invalidSerials: 'Podaj od 1 do 10000 różnych numerów: każdy ma osiem znaków szesnastkowych.',
    invalidQuota: 'Limit musi być liczbą całkowitą od 1 do liczby numerów.',
    invalidApn: 'Wybierz APN z odczytanej listy albo połączenie automatyczne.',
    invalidRevisions: 'Podaj od 1 do 1000 rewizji w poprawnym zapisie szesnastkowym.',
    entries: 'Odrzucone numery',
    entryIndex: 'Pozycja',
    entryValue: 'Wartość',
    entryCode: 'Powód',
    entriesWindow: 'Pokazano pierwsze 20 błędów.',
    entriesTotal: 'Łączna liczba błędów',
    duplicatesTitle: 'Zduplikowane numery seryjne',
    duplicatesHint:
        'Usuń duplikaty, aby przejść do potwierdzenia. Zachowany zostaje pierwszy numer z każdej grupy.',
    removeDuplicates: 'Usuń duplikaty',
    removeConflicts: 'Usuń odrzucone numery i wróć do edycji',
    error: 'Błąd',
};
